import React from "react";
import Page from "../app/page";

export default function Home() {
  return <Page />;
}
